import axios from 'axios';
import {
    FETCH_PAGE_FAILURE,
    FETCH_PAGE_REQUEST,
    FETCH_PAGE_SUCCESS,
} from '../constants/pageTypes';

const fetchPageRequest = () => {
    return {
        type: FETCH_PAGE_REQUEST,
    };
};

const fetchPageSuccess = (payload) => {
    return {
        type: FETCH_PAGE_SUCCESS,
        payload,
    };
};

const fetchPageFailure = (error) => {
    return {
        type: FETCH_PAGE_FAILURE,
        payload: error,
    };
};

export const fetchPage = ({ link, locale = 'de' }) => {
    return (dispatch) => {
        dispatch(fetchPageRequest);
        const params = {
            locale,
            'filters[link][$eq]': link,
        };

        axios
            .get(`${process.env.REACT_APP_CMS_URL}/pages`, { params })
            .then((response) => {
                const pages = response.data;
                dispatch(fetchPageSuccess(pages));
            })
            .catch((error) => {
                const errorMsg = error.message;
                dispatch(fetchPageFailure(errorMsg));
            });
    };
};

export default fetchPage;
